export function getNumberOfVisibleAxes(widgets: Widget[] = [], minAxes = 6): number {
    return widgets.reduce((state, widget) => {
        if (!widget?.jsonConfig?.numberOfVisibleAxes) return state

        const axes = parseInt(String(widget.jsonConfig.numberOfVisibleAxes))
        if (!isFinite) return state

        return Math.max(axes, state)

    }, minAxes)
}
